import { render, staticRenderFns } from "./oddsauto.vue?vue&type=template&id=449f4961&"
import script from "./oddsauto.vue?vue&type=script&lang=js&"
export * from "./oddsauto.vue?vue&type=script&lang=js&"
import style0 from "./oddsauto.vue?vue&type=style&index=0&id=449f4961&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports